import ThemeData from "./theme-data.json"
import { ThemeProvider, createTheme, makeStyles } from "@material-ui/core/styles"

const theme = createTheme(ThemeData)

export { theme }
